// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__SnFVZ","text":"styles_text__odDQa","score":"styles_score__1IXJH"};